
import { AnalyticsProvider } from './../../providers/analytics/analytics';
import { FileDownloaderProvider } from './../../providers/file-downloader/file-downloader';
import { Platform } from 'ionic-angular';
import { Subscription } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import saveAs from 'file-saver';
import { LoopBackAuth } from "../../shared/sdk";
import { ReportApi } from '../../shared/nestjs/gd-only/services/report.api';
import { NestResponsesProvider } from '../../shared/nestjs/nest-responses';
import { EventNameAnalytics } from '../../helpers/event-name-analytics';

@Injectable()
export class EmployeeListReportBloc {
  private filename = 'Employee Report'
  private filenameExcel = 'Employee Report.xlsx';
  private filenamePdf = 'Employee Report.pdf';
  private subscriptions: Array<Subscription> = [];

  constructor(
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    private reportApi: ReportApi,
    private analyticsProvider: AnalyticsProvider,
    private platform: Platform,
    private fileDownloaderProvider: FileDownloaderProvider,
    public nestResponse: NestResponsesProvider,
  ) { }

  dispose() {
    this.subscriptions.forEach(subs => subs.unsubscribe())
  }

  downloadExcel(data) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.reportApi.employeeListDownloadExcel(data)
          .subscribe((result) => {
            this.generateExcel(result);
            this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
            resolve(result)
          }, error => {
            reject(error);
          })
      )
    })
  }

  downloadPdf(data) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.reportApi.employeeListDownloadPdf(data)
          .subscribe((result) => {
            this.generatePdf(result);
            this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
            resolve(result)
          }, error => {
            reject(error)
          })
      )
    })
  }

  generateExcel(data) {
    if (this.platform.is('cordova')) {
      this.fileDownloaderProvider.downloadExcelBlob(data, this.filename)
    } else {
      saveAs(data, this.filenameExcel)
    }
  }

  generatePdf(data) {
    if (this.platform.is('cordova')) {
      this.fileDownloaderProvider.downloadPdfBlob(data, this.filename)
    } else {
      saveAs(data, this.filenamePdf)
    }
  }

  preview(data) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.reportApi.employeeListPreview(data)
          .map(res => res.data[0])
          .subscribe((result) => {
            resolve(result)
          }, error => {
            reject(error)
          })
      )
    })
  }

  employeeSendMail(data) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.reportApi.employeeSendMail(data)
          .map(res => res.data)
          .subscribe((result) => {
            this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
            resolve(result)
          }, error => {
            reject(error)
          })
      )
    })
  }
}


// WEBPACK FOOTER //
// ./src/bloc/report/employee-list-report.bloc.ts